import React from 'react'
import styled from 'styled-components'
import Dashboard from '@material-ui/icons/Dashboard';
import { Link } from 'react-router-dom';
import { FaAddressCard } from "react-icons/fa";
import { ImProfile } from "react-icons/im";
import { CgLogOut } from "react-icons/cg";
import { useState } from 'react';

const SideBarContainer = styled.div`
  flex: 1;
  height: 100vh; /* use 100vh instead of 100% */
  background: #eff5f5;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background-color: #f5f5f5;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #eff5f5;
    border-radius: 10px;
  }
  @media (max-width: 768px) {
    position: fixed;
    z-index: 1;
    top: 0;
    left: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    width: 100%;
    height: 100%;
    transition: all 0.3s ease-in-out;
  }
`;

const SideBarWrapper = styled.div`
  padding: 20px;
  margin-top: 40px;
  color: #555;
`;
const SideBarMenu = styled.div`
  margin-bottom: 10px;
`;
const SideBarTitle = styled.h1`
  font-size: 13px;
  padding: 5px;
`;
const SidebarList = styled.ul`
  list-style: none;
  padding: 5px;
`;
const SidebarListItem = styled.li`
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 10px;
  &:hover {
    background: #eee;
  }
`;
const Hamburger = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    font-size: 1.8rem;
    z-index: 2;
  }
`;

const SideBar = ({ setIsLoggedIn }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.clear();
    window.location.href('/Login');
    window.location.reload();
  };

  return (
    <>
      <Hamburger onClick={() => setIsOpen(!isOpen)}>&#9776;</Hamburger>
      <SideBarContainer isOpen={isOpen}>
      <SideBarWrapper>
        <SideBarMenu>
          {/* <SideBarTitle>Dashboard</SideBarTitle> */}
          <SidebarList>
              <Link to="/" className="link" onClick={() => setIsOpen(false)}>
              <SidebarListItem>
                <Dashboard />
                Home
              </SidebarListItem>
            </Link>
          </SidebarList>
        </SideBarMenu>
        {/* <SideBarTitle>Profile</SideBarTitle> */}
        <SidebarList>
            <Link to="/Profile" className="link" onClick={() => setIsOpen(false)}>
            <SidebarListItem>
              <ImProfile style={{ marginRight: "8px" }} />
              View Profile
            </SidebarListItem>
          </Link>
        </SidebarList>

          <SidebarList>
            <Link to="/Department" className="link" onClick={() => setIsOpen(false)}>
              <SidebarListItem>
                <ImProfile style={{ marginRight: "8px" }} />
                Department Case
              </SidebarListItem>
            </Link>
          </SidebarList>

          <SidebarList>
            <Link to="/Taskmanagement" className="link" onClick={() => setIsOpen(false)}>
              <SidebarListItem>
                <ImProfile style={{ marginRight: "8px" }} />
                Task Management
              </SidebarListItem>
            </Link>
          </SidebarList>

          <SidebarList>
            <Link to="/Legalcalander" className="link" onClick={() => setIsOpen(false)}>
              <SidebarListItem>
                <ImProfile style={{ marginRight: "8px" }} />
                Legal Calendar
              </SidebarListItem>
            </Link>
          </SidebarList>

          <SidebarList>
            <Link to="/Notifications" className="link" onClick={() => setIsOpen(false)}>
              <SidebarListItem>
                <ImProfile style={{ marginRight: "8px" }} />
                Notifications
              </SidebarListItem>
            </Link>
          </SidebarList>

          <SidebarList>
            <Link to="/Login" className="link" onClick={() => setIsOpen(false)}>
              <SidebarListItem onClick={handleLogout}>
                <CgLogOut style={{ marginRight: "8px" }} />
                Logout
              </SidebarListItem>
            </Link>
          </SidebarList>
          
        {/* <SideBarMenu>
          <SideBarTitle>Others</SideBarTitle>
          <SidebarList>
              <Link to="/Login" className="link" onClick={() => setIsOpen(false)}>
              <SidebarListItem onClick={handleLogout}>
                <CgLogOut style={{ marginRight: "8px" }} />
                 Logout
              </SidebarListItem>
            </Link>
          </SidebarList>
        </SideBarMenu> */}

        
      </SideBarWrapper>
    </SideBarContainer>
    </>
  );
}

export default SideBar